import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      companyAnalysis: {
        ...store.getState().i18n.translations.en.companyAnalysis,
        ownershipAndGroup: {
          PARENT_COMPANIES: 'Parent Company',
          BRANCHES: 'Branches',
          RELATED_COMPANIES: 'Related Companies',
          SUBSIDIARIES: 'Subsidiaries',
          ASSOCIATE_COMPANIES: 'Associate Companies',
          OWNERSHIP_STRUCTURE: 'Ownership Structure',
          VIEW_BY: 'View by:',
          MAJOR_SHAREHOLDERS: 'Major Shareholders',
          OWNERSHIP_TYPES: 'Ownership Types',
          NAME: 'Name',
          TYPE: 'Type',
          PERCENTAGE: 'Percentage',
          COUNTRY: 'Country',
          TAX_CODE: 'Tax Code',
          PUBLICATION_DATE: 'Publication Date',
          COMPANY_NAME: 'Company Name',
          ADDRESS: 'Address',
          RELATIONSHIP: 'Relationship',
          STATUS: 'Status',
          STATUS_RES: 'Status',
          CO_DIRECTORS: 'Co-Directors',
          CO_DIRECTORS_RES: 'Co-Directors',
          CO_SHAREHOLDERS: 'Co-Shareholders',
          CO_SHAREHOLDERS_RES: 'Co-Shareholders',
          CO_LEGAL_REPRESENTATIVES: 'Co-Legal Representatives',
          CO_LEGAL_REPRESENTATIVES_RES: 'Co-Legal Representatives',
          ID: '#',
          ASSOCIATE_COMPANIES_NO_DATA: `There is no record of the Company's associate companies`,
          BRANCHES_NO_DATA: `There is no record of the Company's branches`,
          PARENT_COMPANIES_NO_DATA: `There is no record of the Company's parent company`,
          SUBSIDIARIES_NO_DATA: `There is no record of the Company's subsidiaries`,
          RELATED_COMPANIES_NO_DATA: `There is no record of the Company's related companies`,
          OWNERSHIP_STRUCTURE_NO_DATA: `There is no record of the Company's shareholders`,
          ALL_ADDRESSES: 'All addresses',
          SAME_DISTRICT: 'Same district',
          OTHERS: 'Others',
          SHOW_HISTORICAL_OWNERSHIP: 'Show historical ownership',
          HISTORICAL_OWNERSHIP: 'Historical Ownership',
          HISTORICAL_OWNERSHIP_DISCLAIMER:
            'Disclaimer: The historical ownership data was recorded and is deemed reliable at the time of publication. FiinGroup makes no representation or warranty regarding the completeness or accuracy of the information presented. Review our ',
          HISTORICAL_OWNERSHIP_DISCLAIMER_NOTE1: ' to learn more',
          HISTORICAL_OWNERSHIP_DISCLAIMER_DATA_POLICY: 'data policy',
          REDIRECT_CONNECT_MAP: 'Radial Map of %{nameCompany}',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      companyAnalysis: {
        ...store.getState().i18n.translations.vi.companyAnalysis,
        ownershipAndGroup: {
          PARENT_COMPANIES: 'Công Ty Mẹ',
          BRANCHES: 'Chi Nhánh',
          RELATED_COMPANIES: 'Công Ty Liên Quan',
          SUBSIDIARIES: 'Công Ty Con',
          ASSOCIATE_COMPANIES: 'Công Ty Liên Kết',
          OWNERSHIP_STRUCTURE: 'Cấu Trúc Sở Hữu',
          VIEW_BY: 'Xem theo:',
          MAJOR_SHAREHOLDERS: 'Cổ Đông Chính',
          OWNERSHIP_TYPES: 'Loại Hình Sở Hữu',
          NAME: 'Tên',
          TYPE: 'Loại Cổ Đông',
          PERCENTAGE: 'Tỷ Lệ Sở Hữu',
          COUNTRY: 'Quốc Gia',
          TAX_CODE: 'Mã Số Thuế',
          PUBLICATION_DATE: 'Ngày Phát Hành',
          COMPANY_NAME: 'Tên Công Ty',
          ADDRESS: 'Địa Chỉ',
          RELATIONSHIP: 'Quan hệ',
          STATUS: 'Trạng Thái Hoạt Động',
          STATUS_RES: 'Trạng Thái <br/> Hoạt Động',
          CO_DIRECTORS: 'Đồng Giám Đốc',
          CO_DIRECTORS_RES: 'Đồng <br/> Giám Đốc',
          CO_SHAREHOLDERS: 'Đồng Cổ Đông',
          CO_SHAREHOLDERS_RES: 'Đồng <br/> Cổ Đông',
          CO_LEGAL_REPRESENTATIVES: 'Chung Đại Diện Pháp Luật',
          CO_LEGAL_REPRESENTATIVES_RES: 'Chung Đại Diện <br/> Pháp Luật',
          ID: '#',
          ASSOCIATE_COMPANIES_NO_DATA:
            'Không có bản ghi về công ty liên kết của công ty này',
          BRANCHES_NO_DATA: 'Không có bản ghi về chi nhánh của công ty này',
          PARENT_COMPANIES_NO_DATA:
            'Không có bản ghi về công ty mẹ của công ty này',
          SUBSIDIARIES_NO_DATA:
            'Không có bản ghi về công ty con của công ty này',
          RELATED_COMPANIES_NO_DATA:
            'Không có bản ghi về công ty liên quan của công ty này',
          OWNERSHIP_STRUCTURE_NO_DATA:
            'Không có bản ghi về cổ đông của công ty này',
          ALL_ADDRESSES: 'Tất cả địa chỉ',
          SAME_DISTRICT: 'Cùng quận',
          OTHERS: 'Khác',
          SHOW_HISTORICAL_OWNERSHIP: 'Xem dữ liệu lịch sử',
          HISTORICAL_OWNERSHIP: 'Dữ liệu lịch sử',
          HISTORICAL_OWNERSHIP_DISCLAIMER:
            'Từ chối trách nhiệm: Dữ liệu cổ đông lịch sử đã được ghi lại và được coi là đáng tin cậy tại thời điểm công bố. FiinGroup không đưa ra bất kì tuyên bố nào về tính đầy đủ hoặc chính xác của thông tin được trình bày. Để biết thêm thông tin, vui lòng xem ',
          HISTORICAL_OWNERSHIP_DISCLAIMER_NOTE1: ' của FiinGroup',
          HISTORICAL_OWNERSHIP_DISCLAIMER_DATA_POLICY: 'chính sách dữ liệu',
          REDIRECT_CONNECT_MAP: 'Xem Sơ đồ quan hệ tỏa tròn của %{nameCompany}',
        },
      },
    },
  }),
)
